import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dealer",
  "use": "icon-dealer-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-dealer\">\r\n<path d=\"M82.8,79.1l-8.5,31.4l-6.2-19.1c0,0,0.3-2.3,2.3-6.6c2-4.3,2.3-6.3-1.6-8.9c-1.8-1.3-4-1.6-6.1-1c-2.1,0.6-3.8,2.2-4.5,4.3\r\n\tc-1.6,4.3,2.9,6.6,2.9,9.2c0,2.6-5.2,21.5-5.2,21.5s-7.5-26.5-9.2-31.2c-13.7,4.1-25.9,13.3-33,27.5l-0.4,0.8\r\n\tc-4.1,8.1,2.1,17.4,11.6,17.4h78.4c9.3,0,15.5-9.1,11.7-17.2C108.1,92.9,96.2,83.5,82.8,79.1C82.8,79.1,82.8,79.1,82.8,79.1z\r\n\t M98,37.1C98,18.7,83.5,3.7,65.5,3.7C47.6,3.7,33,18.7,33,37.1c0,18.4,14.6,33.3,32.5,33.3S98,55.5,98,37.1C98,37.1,98,37.1,98,37.1\r\n\tz\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dealer.svg
// module id = gOOh
// module chunks = 171